/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { PlacesService } from '../places.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ReferencedPlace } from '../referenced-place.model';
import { Place } from '../place.model';

//TODO rename to iriro-places-picker
@Component({
  selector: 'iric-places-picker, iriro-places-picker',
  templateUrl: './places-picker.component.html',
  styleUrls: ['./places-picker.component.scss'],
})
export class PlacesPickerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() id: string | undefined = undefined;
  @Input() name: string | undefined = undefined;
  @Input() type: string | undefined = undefined;
  @Input() buttonDisabled: boolean | undefined = undefined;

  places: Array<Place> = [];

  constructor(
    private readonly placesService: PlacesService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly httpClient: HttpClient
  ) {}

  private _referencedPlaces: Array<ReferencedPlace> | undefined = undefined;

  get referencedPlaces() {
    return this._referencedPlaces;
  }

  @Input()
  set referencedPlaces(value: ReferencedPlace[]) {
    this._referencedPlaces = value;
    if (this._referencedPlaces) {
      this._referencedPlaces.map((referencedPlace) => {
        this.httpClient.get(`/api/places/${referencedPlace.placeUuid}`).subscribe((place) => {
          console.log(this.id);
          this.places.push(place);
          this.placesService.selectPlace(this.id, place);
        });
      });
    }
  }

  ngOnInit() {
    this.placesService.placesSelected.subscribe((data) => {
      if (data.key === this.id) {
        this.places = data.places;
      }
    });

    this.placesService.placeSelected.subscribe(() => {
      this.places = this.placesService.places[this.id];
    });

    /*   // TODO refactor this
       this.httpClient.get(`/api/referenced-places?filter[refPlaceUuid][EQ]=${this.id}`).subscribe((res) => {
           const referencedPlaces = res['_embedded'].resources;
           if (referencedPlaces) {
               referencedPlaces.map(referencedPlace => {
                   this.httpClient.get(`/api/places/${referencedPlace.placeUuid}`).subscribe((place) => {
                       console.log(this.id);
                       this.places.push(place);
                       this.placesService.selectPlace(this.id, place);
                   });
               })
           }
       });*/
    /*  if (this.referencedPlaces) {
          this.referencedPlaces.map(referencedPlace => {
              this.httpClient.get(`/api/places/${referencedPlace.placeUuid}`).subscribe((place) => {
                  console.log(this.id);
                  this.places.push(place);
                  this.placesService.selectPlace(this.id, place);
              });
          })
      }*/
  }

  openPlacesPopup() {
    this.router.navigate(['/', { outlets: { popup: ['routesheet', 'ref-place', this.id, this.name, this.type] } }], {
      relativeTo: this.route,
    });
  }

  ngOnDestroy() {
    this.placesService.places = {};
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }
}
